function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import TextareaEditorComponent from './components/TextareaEditorComponent';

var Textarea = function Textarea(components) {
  _classCallCheck(this, Textarea);

  components.onGetComponent('viewer', function () {
    return TextareaEditorComponent;
  });
};

export { Textarea as default };
Textarea.$inject = ['components'];
//# sourceMappingURL=TextareaEditor.js.map